import {
  convertStringToCurrencyWithDecimalNegative,
  getDecimalPointNumber,
  isNumeric
} from "./genericFunctions";
import stringToNumber from "./stringToNumber";

export const getAdjustedItems = (id: string, input: any, creditItems: any) => {
  const prevValue = JSON.parse(JSON.stringify(creditItems))[id].value;
  // eslint-disable-next-line no-useless-escape
  const parsedVal = input.replace(/[^0-9-.]+/g, "").trim();

  // Test if number is numeric
  if (parsedVal !== "-" && !isNumeric(parsedVal)) {
    return null;
  }
  const fixedValue =
    parsedVal === "-" && prevValue?.length > 1
      ? ""
      : getDecimalPointNumber(parsedVal, 2);
  const newAdjItems = JSON.parse(JSON.stringify(creditItems));
  const valueIsNotANumber = fixedValue[fixedValue?.length - 1] === ".";
  newAdjItems[id].value = convertStringToCurrencyWithDecimalNegative(
    valueIsNotANumber,
    fixedValue
  );
  newAdjItems.total.value = 0;

  Object.values(newAdjItems).forEach((item: any) => {
    if (item.id === "total" || item.id === "valuation") return;
    newAdjItems.total.value += stringToNumber(item.value || "") || 0;
  });

  newAdjItems.total.value = newAdjItems.total.value.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });
  return newAdjItems;
};
